
define('text!plugins/textbox/template.html',[],function () { return '<div class="row">\n    <div class="large-12 small-centered columns">\n        <input type="text" data-rv-id="model:_id" data-rv-placeholder="model:type" data-rv-value="model:value">\n        <small class="error" data-rv-show="model:hasError" data-rv-text="model:errorMessage"></small>\n    </div>\n</div>\n';});

